import { ApiModel } from './api-model';
import { Moment } from 'moment';
import * as moment from 'moment';
import { Value } from './value';
import { ReferentialEntity } from './referential-entity';
import { Picture } from './picture';
import { ProgramArticlePictureETTValue } from './program-article-translation-value';

export class Rule extends ApiModel {
  id: number;
  ruleId: Value;
  value: string;
  lastUpdatedDate: object;
  validityStartDate: object;
  validityEndDate: object;
  startDate: Date;
  endDate: Date;
  lastUpdate: Moment;
  wysiwyg: string;
  overview: string[];
  overviewShort: string[]
  sport: ReferentialEntity;
  competition: ReferentialEntity;
  event: ReferentialEntity;
  discipline: ReferentialEntity;
  round: ReferentialEntity;
  gender: ReferentialEntity;
  age: ReferentialEntity;
  group: ReferentialEntity;
  type: ReferentialEntity;
  label: ReferentialEntity;
  category: ReferentialEntity;
  infosupp: ReferentialEntity;
  leg: ReferentialEntity;
  broadcasting: ReferentialEntity;
  channel: ReferentialEntity;
  channelGroupid: number;
  classification: string;
  for: number;
  applyTo: string[];
  supportKind: Object;
  valueRule: string;
  pictures: ProgramArticlePictureETTValue[];
  languageId: number;
  languages: number[];
  linkedRules: number[];
  createdBy: number;
  updatedBy: number;
  updatedByUser: string;
  field: Value;
  destination: Value;
  channelGroupName: string;
  isActive: boolean;

  constructor(data: any) {
    if (data.validityStartDate && data.validityStartDate.value && moment(data.validityStartDate.value).toDate().getTime() > 0) {
      data.startDate = moment(data.validityStartDate.value).toDate();
    }
    if (data.validityEndDate && data.validityEndDate.value && moment(data.validityEndDate.value).toDate().getTime() > 0) {
      data.endDate = moment(data.validityEndDate.value).toDate();
    }
    if (data.lastUpdatedDate && data.lastUpdatedDate.value && moment(data.lastUpdatedDate.value).toDate().getTime() > 0) {
      data.lastUpdate = moment(data.lastUpdatedDate.value);
    }
    if (data.picture) {
      data.picture = new Picture(data.picture);
    }
    super(data);
    this.wysiwyg = '';
    if (data.supportKind && this.applyTo.length === 0) {
      this.applyTo.push(data.supportKind.value);
    }
    if (!this.id) {
      this.languages = [];
    }
    this.linkedRules = [];

    this.updatedByUser = data.updatedByUser === '' ? '' : 'Updated by ' + data.updatedByUser;
  }

  setDates() {
    this.validityStartDate = {
      value: this.startDate
    };
    this.validityEndDate = {
      value: this.endDate
    };

  }
}



// WEBPACK FOOTER //
// ./src/app/models/rule.ts